export default __webpack_public_path__ + "static/media/226974EF-1A26-483F-A59E-9F03898F365F_1_105_c.b3a9e679.jpeg";